import * as styles from "./DrawerGrabber.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { DrawerGrabberProps } from "./Drawer.types";

/**
 * Purely visual drag affordance for drawers using `snapPoints` — Base UI
 * itself already handles the drag gesture on the popup, this just makes it
 * discoverable. Unrelated to Base UI's own `Drawer.createHandle`, which
 * connects detached triggers to a drawer and isn't used here.
 */
export function DrawerGrabber({
  className,
  ...props
}: DrawerGrabberProps): JSX.Element {
  return (
    <div
      data-slot="drawer-grabber"
      aria-hidden="true"
      className={clsx(styles.grabber, className)}
      {...props}
    />
  );
}
